import { localeToLang } from '@/shared/i18n/localeToLang';
import { Language, LocalizedString } from '@/shared/model/Language';

export const getLocalizedValue = (
    localizedValue: LocalizedString | undefined,
    locale: string,
    withFallback?: boolean,
): string => {
    if (!localizedValue) {
        return '';
    }
    const lang = localeToLang(locale);
    const shortLang = lang.split('_')[0] as Language;
    return (
        localizedValue?.[lang] ||
        localizedValue?.[shortLang] ||
        (withFallback
            ? localizedValue[
                  (Object.keys(localizedValue).find((key) => key.startsWith(Language.EN)) as
                      | Language
                      | undefined) ?? Language.EN_GB
              ] || ''
            : '')
    );
};
